import * as React from 'react';

import CMLParser from 'bundles/cml/legacy/models/CMLParser';
import type { CmlContent } from 'bundles/cml/legacy/types/Content';
import Tex from 'bundles/phoenix/components/Tex';

type Props = {
  cml: CmlContent;
  forceRender?: boolean;
};

/**
 * CMLText
 * Renders inner text of a given CML object
 */
const CMLText = ({ cml, forceRender = false }: Props) => {
  const parser = new CMLParser(cml.definition.value);

  return (
    <div className="rc-CMLText">
      <Tex forceRender={forceRender}>{CMLParser.getInnerText(parser.getRoot())}</Tex>
    </div>
  );
};

export default CMLText;
